<template>
    <div>
        <app-login-component>
            <template slot="title">
                    <div class="font-title-normal">Passwort vergessen?</div>
                <div id="line-height">
                    <div class="font-normal">Bitte gib deine Email Adresse ein, wir senden dir ein neuws Passwort
                    </div>
                </div>

            </template>
            <template slot="btn">
                <router-link to="/login">Neues Passwort anfordern</router-link>
            </template>
            <template slot="bottom-btn">
                <div class="font-size-btn bottom-btn">Zurück zum Login</div>
            </template>
        </app-login-component>
    </div>
</template>

<script>
  import LoginComponent from '../components/login/LoginComponent'

  export default {
    components: {
      appLoginComponent: LoginComponent
    }
  }
</script>

<style lang="scss" scoped>
    .font-title-normal {
        padding-top: 5px;
    }
    #line-height {
        line-height: 200%;
    }
</style>
